import {useTenant} from "../../hooks";
import {clsx} from "clsx";
import {useTenantTheme} from "../../context/useSystemTenantStore";

export default function Pill({title}) {
  const theme = useTenantTheme();
  return (
    <div className={clsx("px-4 py-2 bg-primaryColor text-white text-md shadow-lg rounded-full h-[35px] max-w-[80px] w-fit flex items-center",
        "items-center")}
         style={{backgroundColor: theme?.primaryHexColor}}>
      {title}
    </div>
  );
}